module.exports = __webpack_public_path__ + "static/media/maple_cursor.a77f6751.cur";